import { Badge } from "primereact/badge";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setPathNormativitiesActiveFiltersTabs, setPathNormativitiesMapFilter, setPathNormativitiesMapFiltersAreExpanded, setPathNormativityAllRaionMapFilterValues, setPathNormativityMapFilterString } from "../../../../../stateManagement/reducers";
import { useAppSelector } from "../../../../../stateManagement/hooks/redux";
import { getItemWebStorage, setItemWebStorage } from "../../../../../features/webStorageSaver";
import { store } from "../../../../../stateManagement/store";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Checkbox } from "primereact/checkbox";
import { classNames } from "primereact/utils";
import { roadBedFiltersOptions } from "../roadBedLayerSegmentsOverlay";
import axios from "axios";
import { capitalize } from "../../../../../features/dataFormatFunctions/dataFormatter";
import { delay } from "../../../../../features/dataFunctions/dataFunctions";

const filtersIcon = require('../../../../../assets/images/icons/filters-icon.svg').default

// Объект конфигурации фильтра "Дороги"
const roadFiltersOptions: any = {
    isOnHighwayNetworkSegment: 'Входят в опорную сеть'
}

export default function PathNormativitiesMapFilters() {
    const dispatch = useDispatch();
    const [raions, setRaions] = useState<any>([]);
    const [fetchRaionsError, setFetchRaionsError] = useState<boolean>(false)
    const [fetchingRaions, setFetchingRaions] = useState<boolean>(false)
    let pathNormativitiesMapFilters = useAppSelector(state => state.diagnosticsPathNormativities.pathNormativitiesMapFilters)
    let ignoreRoadBedTypesMapFilter = useAppSelector(state => state.diagnosticsPathNormativities.pathNormativitiesMapFilters.roadBedTypes.ignoreRoadBedTypes)
    let ignoreRaionMapFilter = useAppSelector(state => state.diagnosticsPathNormativities.pathNormativitiesMapFilters.raions.ignoreRaions)
    let pathNormativitiesActiveFiltersTabs = useAppSelector(state => state.diagnosticsPathNormativities.activeFiltersTabs)
    let pathNormativitiesMapFiltersAreExpanded = useAppSelector(state => state.diagnosticsPathNormativities.pathNormativitiesMapFiltersAreExpanded)

    const currentConfig = getItemWebStorage('currentConfig')

    useEffect(() => {
        fetchRaions(null, true)
    }, [location])

    function configurePathNormativitiesMapFiltersString(pathNormativitiesMapFilters: any) {
        const { isOnHighwayNetworkSegment, roadBedTypes, raions } = pathNormativitiesMapFilters ?? {}
        let layerFilter = ''
        if (isOnHighwayNetworkSegment) {
            layerFilter += ` and HighwayNetwork=1`
        }
        if (roadBedTypes && !roadBedTypes?.ignoreRoadBedTypes) {
            let roadBedFiltersArray
            let roadBedFiltersTempArrayActive = Object.entries(roadBedTypes).filter(([key, value]) => (value === true && key !== 'noRoadBedType')).map(([key, value]) => key)
            if (roadBedFiltersTempArrayActive.length === 0) {
                if (!roadBedTypes?.noRoadBedType) {
                    layerFilter += ` and (PavementType IS NULL and PavementType IS NOT NULL)`
                } else {
                    layerFilter += ` and (PavementType IS NULL)`
                }
            } else {
                roadBedFiltersArray = roadBedFiltersTempArrayActive.map(key => key === 'noRoadBedType' ? null : roadBedFiltersOptions[key].roadbedTypeId).filter(item => item != null)
                layerFilter += ` and (PavementType in (${roadBedFiltersArray?.join(',')})`
                if (roadBedTypes?.noRoadBedType) {
                    layerFilter += ` or PavementType IS NULL)`
                } else {
                    layerFilter += ')'
                }
            }
        }
        if (raions && !raions?.ignoreRaions) {
            let raionsFiltersArray
            let raionsFiltersArrayActive = Object.entries(raions).filter(([key, value]) => (value === true && key !== 'noRaion')).map(([key, value]) => key)
            if (raionsFiltersArrayActive.length === 0) {
                if (!raions?.noRaion) {
                    layerFilter += ` and (RaionId IS NULL and RaionId IS NOT NULL)`
                } else {
                    layerFilter += ` and (RaionId IS NULL)`
                }
            } else {
                raionsFiltersArray = Object.entries(raions).filter(([key, value]) => (value === true && key !== 'noRaion')).map(([key, value]) => key)
                layerFilter += ` and (RaionId in (${raionsFiltersArray?.join(',')})`
                if (raions?.noRaion) {
                    layerFilter += ` or RaionId IS NULL)`
                } else {
                    layerFilter += ')'
                }
            }
        }
        dispatch(setPathNormativityMapFilterString(layerFilter))
    }

    useEffect(() => {
        configurePathNormativitiesMapFiltersString(pathNormativitiesMapFilters)
    }, [pathNormativitiesMapFilters])

    async function fetchRaions(event?: any, firstRender?: any) {
        setFetchRaionsError(false)
        setFetchingRaions(true)
        let apiUrl = currentConfig?.irosRestApiUrl
        const token = store.getState().auth.tokens.app
        let url = `${apiUrl}/Dicts/Raions`
        if (event?.target?.value) {
            url += `?$filter=(position('${event?.target?.value}', Name) gt 0)`
        }
        try {
            const response = await axios.get(url, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const raions = response.data.value;
            setRaions(raions)
            setFetchingRaions(false)
            if (firstRender) {
                let allRaionIds = raions.map((raion: any) => raion.RaionId)
                dispatch(setPathNormativityAllRaionMapFilterValues(allRaionIds))
            }
        } catch (error) {
            setFetchingRaions(false)
            setFetchRaionsError(true)
        }
    }

    function onCheckPathNormativitiesFilters(fieldName: string, event: any, type: string) {
        let localState: any = {}
        Object.assign(localState, store.getState().diagnosticsPathNormativities.pathNormativitiesMapFilters)
        if (type === 'isOnHighwayNetworkSegment') {
            setItemWebStorage('pathNormativitiesMapFilters', { ...localState, [fieldName]: event.checked })
            dispatch(setPathNormativitiesMapFilter({ ...pathNormativitiesMapFilters, [fieldName]: event.checked }))
        }
        if (type === 'roadBedTypes') {
            let localRoadBedTypes: any = {}
            Object.assign(localRoadBedTypes, localState?.roadBedTypes)
            Object.assign(localRoadBedTypes, { [fieldName]: event.checked })
            if (fieldName !== 'ignoreRoadBedTypes') {
                Object.assign(localRoadBedTypes, { ignoreRoadBedTypes: false })
            }
            setItemWebStorage('pathNormativitiesMapFilters', { ...localState, roadBedTypes: localRoadBedTypes })
            dispatch(setPathNormativitiesMapFilter({ ...pathNormativitiesMapFilters, roadBedTypes: localRoadBedTypes }))
        }
        if (type === 'raions') {
            let localRaions: any = {}
            Object.assign(localRaions, localState?.raions)
            Object.assign(localRaions, { [fieldName]: event.checked })
            if (fieldName !== 'ignoreRaions') {
                Object.assign(localRaions, { ignoreRaions: false })
            }
            setItemWebStorage('pathNormativitiesMapFilters', { ...localState, raions: localRaions })
            dispatch(setPathNormativitiesMapFilter({ ...pathNormativitiesMapFilters, raions: localRaions }))
        }
    }
    // функция для подсчета всех активных полей для конкретного фильтра участков нормативности
    function countAllActiveValuesForFilter(localState: any, field: string) {
        return Object.keys(localState[field]).filter((key: any) => (key != `ignore${capitalize(field)}` && localState[field][key])).length
    }

    // функция для подсчета всех активных полей для всех фильтров участков нормативности
    function countAllActiveValuesForAllFilters() {
        let localState: any = store.getState().diagnosticsPathNormativities.pathNormativitiesMapFilters
        let numberOfActiveFilters
        if (!localState.raions.ignoreRaions) {
            numberOfActiveFilters = !numberOfActiveFilters ? 0 : numberOfActiveFilters
            numberOfActiveFilters += countAllActiveValuesForFilter(localState, 'raions')
        }
        if (!localState.roadBedTypes.ignoreRoadBedTypes) {
            numberOfActiveFilters = !numberOfActiveFilters ? 0 : numberOfActiveFilters
            numberOfActiveFilters += countAllActiveValuesForFilter(localState, 'roadBedTypes')
        }
        if (localState?.isOnHighwayNetworkSegment) {
            numberOfActiveFilters = !numberOfActiveFilters ? 0 : numberOfActiveFilters
            numberOfActiveFilters += [localState?.isOnHighwayNetworkSegment].filter(item => item).length
        }
        return numberOfActiveFilters
    }

    // очищение всех фильтров участков нормативности
    function handleClearAllFiltersPathNormativities() {
        if (countAllActiveValuesForAllFilters() != undefined) {
            const pathNormativitiesFiltersInitialState = {
                isOnHighwayNetworkSegment: false,
                roadBedTypes: {
                    ignoreRoadBedTypes: true
                },
                raions: {
                    ignoreRaions: true
                }
            }
            setItemWebStorage('pathNormativitiesMapFilters', pathNormativitiesFiltersInitialState)
            dispatch(setPathNormativitiesMapFilter(pathNormativitiesFiltersInitialState))
        }
    }

    // Функция для получения шаблона заголовка аккордеона для фильтров карты участков нормативности
    function getAccordionHeaderPathNormativitiesTemplate(name: string, type: string) {
        let localState: any = store.getState().diagnosticsPathNormativities.pathNormativitiesMapFilters
        let showClearFiltersButton
        let numberOfActiveFilters
        if (type === 'raions') {
            showClearFiltersButton = !localState.raions.ignoreRaions
            numberOfActiveFilters = countAllActiveValuesForFilter(localState, 'raions')
        }
        if (type === 'roadBedTypes') {
            showClearFiltersButton = !localState.roadBedTypes.ignoreRoadBedTypes
            numberOfActiveFilters = countAllActiveValuesForFilter(localState, 'roadBedTypes')
        }
        if (type === 'isOnHighwayNetworkSegment') {
            showClearFiltersButton = localState?.isOnHighwayNetworkSegment
            numberOfActiveFilters = [localState?.isOnHighwayNetworkSegment].filter(item => item).length
        }
        return (
            <div className="map-overlay-filter-header-div">
                <span className="map-overlay-filter-header-name p-overlay-badge">
                    {name}
                    {showClearFiltersButton &&
                        <Badge value={numberOfActiveFilters}></Badge>
                    }
                </span>
                {showClearFiltersButton &&
                    <Button onClick={(event) => handleClearFiltersPathNormativities(event, type)} className="map-overlay-filter-header-clear-but" severity="secondary" icon="pi pi-filter-slash" rounded outlined />
                }
            </div>
        )
    }

    // функция для очищения одного фильтра участков нормативности
    function handleClearFiltersPathNormativities(event: any, type: any) {
        event.stopPropagation()
        event.preventDefault()
        let localState: any = {}
        Object.assign(localState, store.getState().diagnosticsPathNormativities.pathNormativitiesMapFilters)
        if (type === 'isOnHighwayNetworkSegment') {
            setItemWebStorage('pathNormativitiesMapFilters', { ...localState, isOnHighwayNetworkSegment: false })
            dispatch(setPathNormativitiesMapFilter({ ...pathNormativitiesMapFilters, isOnHighwayNetworkSegment: false }))
        }
        if (type === 'roadBedTypes') {
            setItemWebStorage('pathNormativitiesMapFilters', { ...localState, roadBedTypes: { ignoreRoadBedTypes: true } })
            dispatch(setPathNormativitiesMapFilter({ ...pathNormativitiesMapFilters, roadBedTypes: { ignoreRoadBedTypes: true } }))
        }
        if (type === 'raions') {
            setItemWebStorage('pathNormativitiesMapFilters', { ...localState, raions: { ignoreRaions: true } })
            dispatch(setPathNormativitiesMapFilter({ ...pathNormativitiesMapFilters, raions: { ignoreRaions: true } }))
        }
    }

    // изменение списка открытых фильтров участков нормативности
    function changePathNormativitiesFiltersActiveTabs(event: any) {
        dispatch(setPathNormativitiesActiveFiltersTabs(event.index))
        setItemWebStorage('pathNormativitiesMapFiltersActiveTabs', event.index)
    }

    // - Класс для галочки типа дорожной одежды
    let roadBedTypesCheckBoxClassName = classNames({
        "filter-checkbox-disabled": ignoreRoadBedTypesMapFilter
    })
    // - Класс для галочки района
    let raionCheckBoxClassName = classNames({
        "filter-checkbox-disabled": ignoreRaionMapFilter
    })
    // - Класс для текста типа дорожной одежды
    let roadBedTypesLabelClassName = classNames({
        "ms-2": true,
        "filter-label-disabled": ignoreRoadBedTypesMapFilter
    })
    // - Класс для текста района
    let raionLabelClassName = classNames({
        "ms-2": true,
        "filter-label-disabled": ignoreRaionMapFilter
    })

    return (
        <>
            <div className="buttons-div">
                {pathNormativitiesMapFiltersAreExpanded &&
                    <Button onClick={handleClearAllFiltersPathNormativities} className="clear-all-filters">Сбросить все фильтры</Button>
                }
                <div className="filters-button-div p-overlay-badge" onClick={() => dispatch(setPathNormativitiesMapFiltersAreExpanded(!pathNormativitiesMapFiltersAreExpanded)) }>
                    <div className="filter-button-image-div">
                        <img src={filtersIcon} />
                    </div>
                    <span>Фильтры</span>
                    {(!pathNormativitiesMapFiltersAreExpanded && countAllActiveValuesForAllFilters() != undefined) &&
                        <Badge value={countAllActiveValuesForAllFilters()}></Badge>
                    }
                </div>
            </div>
            {pathNormativitiesMapFiltersAreExpanded &&
                <div className="filters-div">
                    <Accordion multiple activeIndex={pathNormativitiesActiveFiltersTabs} onTabChange={(event) => changePathNormativitiesFiltersActiveTabs(event)}>
                        <AccordionTab header={getAccordionHeaderPathNormativitiesTemplate("Дороги", 'isOnHighwayNetworkSegment')}  >
                            {Object.keys(roadFiltersOptions).map((key => {
                                return (
                                    <div className="map-hint-filters-checkbox-div">
                                        <Checkbox
                                            inputId={`${key}`}
                                            name={`${key}`}
                                            onChange={(event: any) => onCheckPathNormativitiesFilters(`${key}`, event, 'isOnHighwayNetworkSegment')}
                                            checked={pathNormativitiesMapFilters[key]}
                                        />
                                        <label htmlFor={`${key}`} className="ms-2">{roadFiltersOptions[key]}</label>
                                    </div>
                                )
                            }))}
                        </AccordionTab>
                        <AccordionTab header={getAccordionHeaderPathNormativitiesTemplate("Тип дорожной одежды", 'roadBedTypes')}>
                            {Object.keys(roadBedFiltersOptions).map((key => {
                                let checked
                                if (pathNormativitiesMapFilters?.hasOwnProperty('roadBedTypes') && pathNormativitiesMapFilters?.roadBedTypes.hasOwnProperty(key)) {
                                    checked = pathNormativitiesMapFilters?.roadBedTypes[key]
                                } else {
                                    checked = false
                                }
                                return (
                                    <div className="map-hint-filters-checkbox-div">
                                        <Checkbox
                                            className={roadBedTypesCheckBoxClassName}
                                            inputId={`${key}PathNormativities`}
                                            name={`${key}`}
                                            onChange={(event: any) => onCheckPathNormativitiesFilters(`${key}`, event, 'roadBedTypes')}
                                            checked={checked}
                                        />
                                        <label htmlFor={`${key}`} className={roadBedTypesLabelClassName}>{roadBedFiltersOptions[key].name}</label>
                                    </div>
                                )
                            }))}
                            <div className="map-hint-filters-checkbox-div">
                                <Checkbox
                                    className={roadBedTypesCheckBoxClassName}
                                    inputId="noRoadBedType"
                                    name="noRoadBedType"
                                    onChange={(event: any) => onCheckPathNormativitiesFilters(`noRoadBedType`, event, 'roadBedTypes')}
                                    checked={pathNormativitiesMapFilters?.roadBedTypes?.noRoadBedType}
                                />
                                <label htmlFor="noRoadBedType" className={roadBedTypesLabelClassName}>Не указан</label>
                            </div>
                            <div className="map-hint-filters-checkbox-div">
                                <Checkbox
                                    inputId="ignoreRoadBedTypes"
                                    onChange={(event: any) => onCheckPathNormativitiesFilters(`ignoreRoadBedTypes`, event, 'roadBedTypes')}
                                    name="ignoreRoadBedTypes"
                                    checked={ignoreRoadBedTypesMapFilter}
                                />
                                <label htmlFor="ignoreRoadBedTypes" className="ms-2">Не учитывать</label>
                            </div>
                        </AccordionTab>
                        <AccordionTab header={getAccordionHeaderPathNormativitiesTemplate("Район", 'raions')}>
                            <div className="filter-list-checkbox">
                                <div className="map-hint-filters-checkbox-div">
                                    <Checkbox
                                        inputId="ignoreRaions"
                                        onChange={(event: any) => onCheckPathNormativitiesFilters(`ignoreRaions`, event, 'raions')}
                                        name="ignoreRaions"
                                        checked={ignoreRaionMapFilter}
                                    />
                                    <label htmlFor="ignoreRaions" className="ms-2">Не учитывать</label>
                                </div>
                                <input onChange={(e: any) => delay(() => fetchRaions(e), 300)} className="list-checkbox-search"></input>
                                {fetchingRaions
                                    ?
                                    <div className="m-2">
                                        <span className="spinner-border spinner-border-sm me-2 ms-2" role="status" aria-hidden="true"></span>
                                        <span>Загрузка...</span>
                                    </div>
                                    :
                                    <>
                                        {fetchRaionsError
                                            ?
                                            <div className="m-2">
                                                <span>Ошибка при загрузке списка районов.</span>
                                            </div>
                                            :
                                            <>
                                                <div className="list-checkbox with-search-container">
                                                    <div className="map-hint-filters-checkbox-div">
                                                        <Checkbox
                                                            className={raionCheckBoxClassName}
                                                            inputId="noRaion"
                                                            name="noRaion"
                                                            onChange={(event: any) => onCheckPathNormativitiesFilters(`noRaion`, event, 'raions')}
                                                            checked={pathNormativitiesMapFilters?.raions?.noRaion}
                                                        />
                                                        <label htmlFor="noRaion" className={raionLabelClassName}>Не указан</label>
                                                    </div>
                                                    {raions.map(((raion: any) => {
                                                        let checked
                                                        if (pathNormativitiesMapFilters?.hasOwnProperty('raions') && pathNormativitiesMapFilters.raions.hasOwnProperty(`${raion.RaionId}`)) {
                                                            checked = pathNormativitiesMapFilters.raions[raion.RaionId]
                                                        } else {
                                                            checked = false
                                                        }
                                                        return (
                                                            <div className="map-hint-filters-checkbox-div">
                                                                <Checkbox
                                                                    className={raionCheckBoxClassName}
                                                                    inputId={`${raion.RaionId}`}
                                                                    onChange={(event: any) => onCheckPathNormativitiesFilters(`${raion.RaionId}`, event, 'raions')}
                                                                    name={`${raion.RaionId}`}
                                                                    checked={checked}
                                                                />
                                                                <label htmlFor={`${raion.RaionId}`} className={raionLabelClassName}>р-н. {raion.Name}</label>
                                                            </div>
                                                        )
                                                    }))}
                                                </div>
                                            </>
                                        }
                                    </>
                                }
                            </div>
                        </AccordionTab>
                    </Accordion>
                </div>
            }
        </>
    )
}
